import React, { useEffect, useRef } from 'react';
const {tableau} = window

export default function TableauUserSales() {
  const ref = useRef(null)
  const url =  "https://public.tableau.com/views/User_16557976603290/User?:language=en-US&publish=yes&:display_count=n&:showShareOptions=false&:origin=viz_share_link&:size=1380,1&:embed=y&:showVizHome=n&:bootstrapWhenNotified=y&:tabs=n&:apiID=host6#navType=1&navSrc=Parse"

  const options = {
    hideTabs: true,
    hideToolbar: true,
  }

  function initViz(){
    new tableau.Viz(ref.current, url, options)
  }

  useEffect(() => {
    initViz()
  }, [])

  return (
    <div ref={ref} style={{width:'100%', height:'100vh'}}></div>
  );
}